import { Folder } from '../server/folder';

export class FolderListUpdatedEvent {
    public constructor(public folder: Folder) {}
}
